import OrdemTec from "../assets/img/www.ordemtec.com.br_.png";
import NossoAtendimento from "../assets/img/nossorestaurante.com.br_.png";

export const projects = [
  {
    id: "ordemtec",
    name: "OrdemTec",
    description:
      "A platform for service companies to manage customers, schedules, service orders, communication, and finances in one place.",
    url: "https://www.ordemtec.com.br/",
    image: OrdemTec,
  },
  {
    id: "nosso-atendimento",
    name: "NossoAtendimento",
    description:
      "A restaurant management system that brings tables, orders, menus, team permissions, and financial tracking together.",
    url: "https://nossorestaurante.com.br/",
    image: NossoAtendimento,
  },
];
